import React from 'react';
import Grid from '@mui/material/Grid';
import LoadingDialog from '../../Loading';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles'
import GetPDFError from '../../GetPDFError';
import PdfViewerFrame from "../pdfViewerFrame.js"

const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    }
})

export default function DisplayForm(props) {
    return (
        <React.Fragment>
            <ThemeProvider theme={inspectionTheme}>
                <Grid style={{ position: "relative", }}>
                    <LoadingDialog load={false} />
                    <CssBaseline />
                    <Grid sx={{ pt: 2, pb: 2 }}>
                        {props?.PDFErrorStatus ?
                            <Grid
                                style={{
                                    border: "2px solid",
                                    borderColor: "#2c2c2c",
                                    height: "70vh",
                                    width: "100%",
                                }}>
                                <GetPDFError loading={props?.PDFErrorStatus} />
                            </Grid>
                            :
                            //<embed
                            //    type="application/pdf"
                            //    src={props?.PDFFile}
                            //    style={{
                            //        border: "2px solid",
                            //        borderColor: "#2c2c2c",
                            //        height: "70vh",
                            //        width: "100%",
                            //    }}
                            ///>
                            <PdfViewerFrame pdfUrl={props?.PDFFile} pdfHeight ='66vh'/>
                        }
                    </Grid>
                </Grid>
            </ThemeProvider >
        </React.Fragment>
    );
}